import { ReactiveMap } from "@solid-primitives/map"
import { createRoot } from "solid-js"

export type KeyDownReactiveMap = ReactiveMap<KeyboardEvent['key'], KeyboardEvent>

export const globalKeyDownReactiveMap = createRoot(() => {
  const map = new ReactiveMap<KeyboardEvent['key'], KeyboardEvent>()
  return map
})
